import React, { useState, useEffect } from 'react';

export function StoreImage({imageUrl, isLocker = false}) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(false);

    if (!imageUrl) {
      return;
    }

    let cancelled = false;

    const image = new Image();

    image.onload = () => {
      if (!cancelled) {
        setLoaded(true);
      }
    };

    image.onerror = () => {
      if (!cancelled) {
        setLoaded(false);
      }
    };

    image.src = imageUrl;

    return () => {
      cancelled = true;
    };
  }, [imageUrl]);

  if (!imageUrl || !loaded) {
    return null;
  }

  const style = {
    backgroundImage: `url("${imageUrl}")`,
    backgroundPosition: "center",
    backgroundSize: isLocker ? "contain" : "cover",
    backgroundRepeat: "no-repeat",
    animation: "fadeIn 0.8s ease-in-out"
  };

  return (
    <div
      key={imageUrl}
      className="store-front-image"
      role="img"
      aria-label="Store front image"
      style={style}
    />
  );
};
